
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { MigrationStatus } from 'enums/MigrationStatus';
import { SiteModel } from './Distribution.Api.Models.Site';
import { MigrationPointerModel } from './Distribution.Api.Models.Migration.MigrationPointer';
import { Model, ModelProperty } from 'models/Model';


export class MigrationSiteModel extends Model<MigrationSiteModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'hostname', type: 'string' },
		{ name: 'companyName', type: 'string' },
		{ name: 'vatNo', type: 'string' },
		{ name: 'ip', type: 'string' },
		{ name: 'ns', type: 'string' },
		{ name: 'siteId', type: 'string' },
		{ name: 'status', type: 'MigrationStatus' },
		{ name: 'migrationSourceId', type: 'string' },
		{ name: 'site', type: 'SiteModel', isHidden: true, isObject: true, new: () => { return new SiteModel }, properties: () => { return SiteModel.classProperties } },
		{ name: 'pointers', type: 'MigrationPointerModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new MigrationPointerModel }, properties: () => { return MigrationPointerModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public hostname: string;
	public companyName: string;
	public vatNo: string;
	public ip: string;
	public ns: string;
	public siteId?: string;
	public status: MigrationStatus;
	public migrationSourceId?: string;
	public site?: SiteModel;
	public pointers: MigrationPointerModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.hostname = '';
		this.companyName = '';
		this.vatNo = '';
		this.ip = '';
		this.ns = '';
		this.siteId = undefined;
		this.status = 0;
		this.migrationSourceId = undefined;
		this.site = undefined;
		this.pointers = [];
		
	}
	getProperties(){
		return MigrationSiteModel.classProperties;
	}
}

